export const MapViewerIframeWindow = () => _.get(document.getElementById('map_viewer_iframe'), 'contentWindow', null);
export const appVersion = '3.9.0';
